export default {"src":"/_next/static/media/np_chevron-down.bb186dfa.svg","height":133,"width":133,"blurWidth":0,"blurHeight":0};